import { ActionType } from '../../actions/ActionType';
import { Action } from '../../actions/membershipReport/GiftForMembersActions';

export interface GiftForMembersState {
    isLoading: boolean;
    error: string | null;
    GiftInfo: {
        giftNo: string;
        giftName: string;
        isDefault: boolean;
    },
}

const initialState = {
    isLoading: false,
    error: null,
    GiftInfo: { giftNo: "", giftName: "", isDefault : false },
};

const giftForMembersReducer = (
    state: GiftForMembersState = initialState,
    action: Action
) => {
    switch (action.type) {
        case ActionType.FETCH_GIFT_NAME_START:
            return {
                isLoading: true,
                error: null,
                GiftInfo: state.GiftInfo,
            };
        case ActionType.FETCH_GIFT_NAME_SUCCESS:
            return {
                isLoading: false,
                error: null,
                GiftInfo: action.payload,
            };
        case ActionType.FETCH_GIFT_NAME_ERROR:
            return {
                isLoading: false,
                error: action.payload,
                GiftInfo: { giftNo: "", giftName: "", isDefault: false },
            };
        default:
            return state;
    }
};

export default giftForMembersReducer;